export default __webpack_public_path__ + "static/FairplexWide-Medium-7b65dca2f29fe6a002cdcf78a8c1789b.woff2";